import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import { format, isValid } from 'date-fns';

const DateTableCell = ({ value, sx }) => {
  const dateValue = useMemo(() => {
    if (!value) return null;
    return new Date(value);
  }, [value]);

  return <TableCell sx={sx}>{dateValue && isValid(dateValue) && format(new Date(value), 'dd.MM.yyyy')}</TableCell>;
};

DateTableCell.propTypes = {
  value: PropTypes.string,
  sx: PropTypes.object
};

export default DateTableCell;
